(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('ReportGroupSearch', ReportGroupSearch);

    ReportGroupSearch.$inject = ['$resource'];

    function ReportGroupSearch($resource) {
        var resourceUrl =  'api/_search/report-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
